import apiClient from './apiClient';

// Dashboard service — mirrors r2b-restaurant-mobile-new/src/services/dashboardService.js.

export const getBranchStats = async (branchId) => {
  const response = await apiClient.get(`/branch-stats/${branchId}`);
  return response.data;
};

export const getDashboardMetrics = async (branchId) => {
  const stats = await getBranchStats(branchId);
  return {
    totalRevenue: stats.totalRevenue || 0,
    totalOrders: stats.totalOrders || 0,
    pendingOrders: stats.pending || 0,
    completedOrders: stats.completed || 0,
    cancelledOrders: stats.cancelled || 0,
    averageOrderValue: stats.averageOrderValue || 0,
    cancellationRate: stats.cancellationRate || 0,
    avgPrepTime: stats.avgPrepTime || 0,
  };
};
